var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmployment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5684",
    fillRule: "evenodd",
    d: "M54.5 8.867H36.371A5.002 5.002 0 0 0 31.5 5h-3a5.002 5.002 0 0 0-4.871 3.867H5.5a3 3 0 0 0-3 3V31a3 3 0 0 0 3 3h27.266c3.338-4.833 8.916-8 15.234-8 3.473 0 6.723.957 9.5 2.622V11.867a3 3 0 0 0-3-3ZM30.833 37.593A18.449 18.449 0 0 0 29.5 44.5c0 1.68.224 3.307.643 4.854H5.5a3 3 0 0 1-3-3V36.24a3.99 3.99 0 0 0 3 1.354h25.333ZM30 28.2c1.38 0 2.5-1.082 2.5-2.417 0-1.334-1.12-2.416-2.5-2.416s-2.5 1.082-2.5 2.416c0 1.335 1.12 2.417 2.5 2.417Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5684",
    fillRule: "evenodd",
    d: "M48 59c8.008 0 14.5-6.492 14.5-14.5S56.008 30 48 30s-14.5 6.492-14.5 14.5S39.992 59 48 59Zm0-4c5.799 0 10.5-4.701 10.5-10.5S53.799 34 48 34s-10.5 4.701-10.5 10.5S42.201 55 48 55Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5684",
    fillRule: "evenodd",
    d: "M47.3 37a1.8 1.8 0 0 0-1.8 1.8v5.4a1.8 1.8 0 0 0 1.056 1.64c.063.092.135.18.217.261l2.553 2.553a1.8 1.8 0 0 0 2.545 0l.283-.283a1.8 1.8 0 0 0 0-2.546l-2.553-2.552a1.815 1.815 0 0 0-.101-.094V38.8a1.8 1.8 0 0 0-1.8-1.8h-.4Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmployment);
export default __webpack_public_path__ + "static/media/icon-employment.a5af431d3da97fdb273bda8b8ef661b2.svg";
export { ForwardRef as ReactComponent };